import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import packageJson from '../package.json'

const buildDateGreaterThan = (latestDate, currentDate) => {
	if (dayjs(latestDate).isAfter(dayjs(currentDate))) {
		return true
	}
	return false
}

function withClearCache(Component) {
	function ClearCacheComponent(props) {
		const [isLatestBuildDate, setIsLatestBuildDate] = useState(false)
		// ! Run npm run build if this throws an error meta.json file should be in public folder
		// biome-ignore lint: Fetching build metadata on mount to check for new deployments and force cache refresh
		useEffect(() => {
			fetch('/meta.json')
				.then((response) => response.json())
				.then((meta) => {
					const latestVersionDate = meta.buildDate
					const currentVersionDate = packageJson.buildDate

					const shouldForceRefresh = buildDateGreaterThan(
						latestVersionDate,
						currentVersionDate
					)
					if (shouldForceRefresh) {
						setIsLatestBuildDate(false)
						refreshCacheAndReload()
					} else {
						setIsLatestBuildDate(true)
					}
				})
		}, [])

		const refreshCacheAndReload = () => {
			if (caches) {
				// Service worker cache should be cleared with caches.delete()
				caches.keys().then((names) => {
					for (const name of names) {
						caches.delete(name)
					}
				})
			}
			// delete browser cache and hard reload
			window.location.reload(true)
		}

		return (
			<React.Fragment>
				{isLatestBuildDate ? <Component {...props} /> : null}
			</React.Fragment>
		)
	}

	return ClearCacheComponent
}

export default withClearCache
